import {
  type FC, useCallback, useRef,
} from 'react';
import { useOnMount } from '~/_shared/hooks/useOnMount';
import { GAEventName } from '~/_shared/utils/3rdPartyIntegrations/ga/ga.types';
import { sendSignupFunnelEvent } from '~/_shared/utils/3rdPartyIntegrations/ga/signupFunnel.helpers';
import { useSsoLogin } from '~/authentication/loginPage/sso/useSsoLogin';
import { RegisterFormComponent } from './registerForm.component';
import { RegisterFormSuccessComponent } from './registerFormSuccess.component';
import { useUserRegister } from './useUserRegister';
import { useUserRegisterFormMessages } from './useUserRegisterMessages';

export const RegisterFormContainer: FC = () => {
  const { registerUser, isLoading } = useUserRegister();
  const { onRegisterSubmit, errors, errorMessage, showSuccessMessage, closeErrorMessage, closeSuccessMessage } = useUserRegisterFormMessages(registerUser);
  const { isLoading: isSsoLoading, onGoogleLogin, onMicrosoftLogin } = useSsoLogin('register');
  const isFormStartTrackedRef = useRef(false);

  useOnMount(() => {
    sendSignupFunnelEvent(GAEventName.SignupPageView, { page: 'register' });
  });

  const onFormStart = useCallback(() => {
    if (!isFormStartTrackedRef.current) {
      isFormStartTrackedRef.current = true;
      sendSignupFunnelEvent(GAEventName.SignupFormStart, { page: 'register', method: 'email' });
    }
  }, []);

  if (showSuccessMessage) {
    return (
      <RegisterFormSuccessComponent onClose={closeSuccessMessage} />
    );
  }

  return (
    <RegisterFormComponent
      closeErrorMessage={closeErrorMessage}
      errorMessage={errorMessage}
      errors={errors}
      isLoading={isLoading || isSsoLoading}
      onFormStart={onFormStart}
      onGoogleLogin={onGoogleLogin}
      onMicrosoftLogin={onMicrosoftLogin}
      // TODO: enable once we can tell whether the user is in the EU
      requireTOS={false}
      onSubmit={onRegisterSubmit}
    />
  );

};
